import {useQuery} from "@tanstack/react-query";
import {ApiConfig} from "@/config/api.config.ts";
import {useAxiosAuth} from "@/hooks/useAxiosAuth.ts";
import {OwnerPermissionsResponseDto} from "@/features/owners/types/owners-dto.ts";

export const useOwnerPermissionsQueryApi = (id: string) => {
    const axiosInstance = useAxiosAuth();

    const {data: permissions, isLoading: isPermissionsLoading} = useQuery({
        queryKey: [ApiConfig.queries.features.owners.permissions.get, id],
        queryFn: async () => {
            const url = ApiConfig.queries.features.owners.permissions.get.endpoint.replace("{ownerId}", id);
            const response = await axiosInstance.get<OwnerPermissionsResponseDto>(url);
            return response.data;
        },
        enabled: !!id,
        refetchOnWindowFocus: false,
    })

    return {
        permissions,
        isPermissionsLoading
    }
}